import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { TiInfo } from 'react-icons/ti';
import { CgSpinner } from 'react-icons/cg';

import Modal from 'common-components/Modal';
import Alert from 'common-components/Alert';
import Button from 'common-components/Button';
import DataTable from 'common-components/DataTable';
import { columns } from './urlDiffTableColumns';
import { getUrlDiffData, publishUrls } from '../../api';
import {
  SERVER_ERROR,
  LOGIN_ERROR
} from 'common-components/Alert/alertMessage.config';
import { BATCH_PUBLISH_OFSET } from '../../config';

import './urlDiffModal.style.css';


const UrlDiffModal = ({
  priviledge,
  authHeader,
  showDiffModal,
  setShowDiffModal
}) => {
  const [alertData, setAlertData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState(null);
  const [urlsToPublish, setUrlsToPublish] = useState(null);
  const [confirmSpinner, setConfirmSpinner] = useState(false);

  const setDefaultColumn = () => {
    if (!columns.some(
      column => { return column.title === "Predicted Category Name" })) {
      columns.push(
        {
          title: "Predicted Category Name",
          key: "original_category_name",
          headerClassName: 'column-pre-cat',
          render: (row) => {
            let theme = row.original_category_name == row.revised_category_name ? 'green' : 'red'
            if (row.original_category_name) return <div className={`cat-container ${theme}`}>{row.original_category_name}</div>;
          },
        }
      );
    };

    if (!columns.some(
      column => { return column.title === "Revised Category Name" })) {
      columns.push(
        {
          title: "Revised Category Name",
          key: "revised_category_name",
          headerClassName: 'column-rev-cat',
          sortable: false,
          render: (row) => {
            if (row.revised_category_name) return <div className='cat-container green'>{row.revised_category_name}</div>;
          },
        });
    };
  };

  const formatData = (data) => {
    let formattedData = [];
    for (let i = 0; i < data.length; i++) {
      let obj = {};
      obj['url'] = data[i].url_meta_data.url.replace("http://", "");
      obj['url_metadata_id'] = data[i].url_meta_data.id
      obj['revised_category_name'] = data[i].revised_category ? data[i].revised_category.detailed_category_name : 'Null';
      obj['revised_detailed_category_id'] = data[i].revised_category ? data[i].revised_category.detailed_category_id : 'Null';
      obj['original_category_name'] = data[i].original_category ? data[i].original_category.detailed_category_name : 'Null';
      obj['original_category_id'] = data[i].original_category ? data[i].original_category.detailed_category_id : 'Null';
      formattedData.push(obj);
    };

    return formattedData;
  };

  const loadDiffOfSavedUrls = async () => {
    setIsLoading(true);

    let data;
    let response = await getUrlDiffData(authHeader);

    if (response && response.status == 401) setAlertData(LOGIN_ERROR);
    else if (response && response.status.toString().match(/2\d{2}/)) data = response.data;
    else setAlertData(SERVER_ERROR);

    let formattedData = formatData(data);
    setTableData(formattedData);
    return true;
  };

  const loadTableData = async () => {
    let status = await loadDiffOfSavedUrls();
    status && setIsLoading(false);
  };

  useEffect(() => {
    if (!tableData) {
      loadTableData()
      setDefaultColumn();
    };
  }, []);

  const isDisabled = () => {
    return (!isLoading && (priviledge.is_admin || priviledge.is_reviewer)) ? false : true
  };

  const onFormSubmit = e => {
    e.preventDefault();

    if (urlsToPublish) {
      setConfirmSpinner(true);
      let payload = urlsToPublish.splice(0, BATCH_PUBLISH_OFSET);
      sessionStorage.setItem('urlsToPublish', JSON.stringify(urlsToPublish));
      publishUrls(payload, window.location.href + '/uridb_published');
    } else {
      setAlertData({
        title: "Insufficient Data",
        description: 'Select atleast one URL to perform this operation.',
        eventName: 'Go back',
        showModal: true,
        type: 'error'
      });
    };
  };

  const selectAction = (selectedRows) => {
    let data = selectedRows.map(({ url, url_metadata_id, revised_detailed_category_id }) => (
      { url, url_metadata_id, revised_detailed_category_id })
    );

    (selectedRows.length > 0) ? setUrlsToPublish(data) : setUrlsToPublish(null);
  };

  const modalContent = () => {
    return (
      <div className='modal-data'>
        <div className='header'>Change Summary</div>
        <form className='form-wrap' onSubmit={(e) => onFormSubmit(e)}>
          <div className='table-container'>
            {<DataTable
              title="URLs TO PUBLISH"
              wrapperClassName='url-diff-table'
              rows={tableData ? tableData : []}
              columns={columns}
              isLoading={isLoading}
              searchableFields={["revised_category_name", "original_category_name"]}
              onSelect={selectAction}
            />}
          </div>
          <div className='publish-menu'>
            <div className='message'>
              <TiInfo className='icon' />
              Confirming will publish the changes to URI database
            </div>
            <div className='confirm'>
              <Button
                type='submit'
                disabled={isDisabled()}
              >
                {confirmSpinner && <CgSpinner className='confirm-spinner spin' />}
                Confirm
              </Button>
            </div>
            <div className='close'>
              <Button
                children='Close'
                onClick={() => setShowDiffModal(false)}
                disabled={isDisabled()}
              />
            </div>
          </div>
        </form>
      </div>
    )
  };

  return (
    <div className='url-diff-container'>
      <Modal
        showModal={showDiffModal}
        setShowModal={setShowDiffModal}
        content={modalContent()}
      />
      <Alert
        showModal={alertData.showModal}
        setShowModal={setAlertData}
        data={alertData}
      />
    </div>
  )
};

const mapStateToProps = ({
  authentication: { priviledge, authHeader } }) => ({
    priviledge,
    authHeader
  });

export default connect(mapStateToProps)(UrlDiffModal);
